import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _PlayroomMarketplaceE, _MarketplaceEmptyStat;
import { useCallback, useEffect, useState } from 'react';
import { useAmplitude } from '@crehana/analytics';
import { ExchangeRewardDialog, MarketplaceEmptyState, PlayroomMarketplaceEmptyState, PlayroomRewardCard } from "../../components";
import { usePlayroomRewards, usePlayroomRewardsTranslations } from "../../hooks";
import { canRedeemElement } from "../../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PlayroomMarketplace = function PlayroomMarketplace(_ref) {
  var organizationSlug = _ref.organizationSlug,
    organizationId = _ref.organizationId,
    crehanaCoinsAvailable = _ref.crehanaCoinsAvailable,
    customCurrencyName = _ref.customCurrencyName,
    onRedeemError = _ref.onRedeemError,
    onRedeemSuccess = _ref.onRedeemSuccess,
    className = _ref.className;
  var _usePlayroomRewardsTr = usePlayroomRewardsTranslations(),
    t = _usePlayroomRewardsTr.t;
  var _usePlayroomRewards = usePlayroomRewards(organizationId),
    rewardList = _usePlayroomRewards.rewardList,
    loading = _usePlayroomRewards.loading,
    refetch = _usePlayroomRewards.refetch;
  var _useAmplitude = useAmplitude(),
    logEvent = _useAmplitude.logEvent;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    selectedReward = _useState2[0],
    setSelectedReward = _useState2[1];
  var onSuccess = useCallback(function (reward) {
    onRedeemSuccess(reward);

    // Refetch rewards after 2 seconds because the API is not real-time
    setTimeout(function () {
      return void refetch();
    }, 2000);
  }, [onRedeemSuccess, refetch]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  var onOpenExchangeItem = useCallback(function (card) {
    return function () {
      setSelectedReward(_objectSpread({}, card));
      logEvent({
        event: 'Game Reward Checked',
        data: {
          'Reward ID': card.originalId,
          'Reward Name': card.title,
          'Currency Points': card.coins,
          'Organization Slug': organizationSlug,
          'Points Available': crehanaCoinsAvailable ? 'Yes' : 'No'
        }
      });
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [logEvent, organizationSlug]);
  var onCloseExchangeItem = useCallback(function () {
    return setSelectedReward(undefined);
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    void refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (loading) {
    return _PlayroomMarketplaceE || (_PlayroomMarketplaceE = /*#__PURE__*/_jsx(PlayroomMarketplaceEmptyState, {
      maxItems: 4,
      animated: true
    }));
  }
  if (rewardList.length === 0) {
    return _MarketplaceEmptyStat || (_MarketplaceEmptyStat = /*#__PURE__*/_jsx(MarketplaceEmptyState, {}));
  }
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx("p", {
      className: "tw-font-body3 tw-mb-2",
      children: t('PRS_SECTION_MARKETPLACE_DESCRIPTION')
    }), /*#__PURE__*/_jsx("div", {
      className: "tw-grid tw-gap-1.6 tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3",
      role: "grid",
      children: rewardList.map(function (reward, index) {
        var canRedeem = canRedeemElement(crehanaCoinsAvailable, reward.coins);
        return /*#__PURE__*/_jsx(PlayroomRewardCard, {
          title: reward.title,
          description: reward.description,
          coins: reward.coins,
          stock: reward.stock,
          imageSrc: reward.imageSrc,
          disabled: !canRedeem,
          "data-testid": "playroom-marketplace-article-".concat(index),
          onExchange: onOpenExchangeItem(reward)
        }, reward.originalId);
      })
    }), !!selectedReward && /*#__PURE__*/_jsx(ExchangeRewardDialog, {
      open: !!selectedReward,
      reward: selectedReward,
      crehanaCoinsAvailable: crehanaCoinsAvailable,
      onRedeemError: onRedeemError,
      onClose: onCloseExchangeItem,
      onConfirmed: onCloseExchangeItem,
      onRedeemSuccess: onSuccess,
      organizationSlug: organizationSlug,
      customCurrencyName: customCurrencyName
    })]
  });
};
export default PlayroomMarketplace;